import React from "react";
import Dropdown from "react-dropdown";
import ContactStyles from "../styles/Contact.module.scss";

const contactSubjects = ["Informations charte LOCAVIE & dossier candidature à l’habitat", "Informations partenariats et investisseurs", "Informations projets en cours et à venir"];

function ContactItem(props) {
	return (
		<div className={ContactStyles.contactItem}>
			<div className={ContactStyles.contactItemLabel}>
				{props.label + (props.mandatory ? "*" : "")}
			</div>

			{props.styleType === "multiline" ? (
				<textarea
					className={ContactStyles.contactItemInputLong}
					placeholder={props.placeholder}
					value={props.value}
					onChange={props.onChange}
					rows={5}
				/>
			) : props.styleType === "dropdown" ? (
				<Dropdown
					options={contactSubjects}
					className={ContactStyles.contactItemInputDropDown}
					placeholder={props.placeholder}
					placeholderClassName={ContactStyles.contactItemInputPlaceholder}
					menuClassName={ContactStyles.contactItemDropdownMenu}
					arrowClassName={ContactStyles.contactItemDropdownArrow}
					controlClassName={ContactStyles.contactItemDropdownControl}
					onChange={(e) => props.onChange(e)}
				/>
			) : (

				<input
					className={ContactStyles.contactItemInput}
					type={props.type ? props.type : ""}
					placeholder={props.placeholder}
					value={props.value}
					onChange={props.onChange}
				/>
			)}
		</div>
	);
}

export default ContactItem;
